import { useEffect } from 'react';

/** Hook for changing title */
export const useTitle = title => {
  useEffect(() => {
    const oldTitle = document.title;
    document.title = 'Hero Oh Hero' + (title ? ` - ${title}` : '');
    // Reset title when component unmounts
    return () => { document.title = oldTitle };
  }, [title]);
};
